module.exports = __webpack_public_path__ + "ptc_nakagawa_F2.0f47fae4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_F2.jpg
// module id = GnHN
// module chunks = 0